import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { fn } from "@ember/helper";
import DButton from "discourse/ui-kit/d-button";

export default class UserProfileWazeChatButton extends Component {
  @service wazeChatSdkPromise;

  static shouldRender(outletArgs, helper) {
    return helper.siteSettings.waze_chat_enabled;
  }

  @action
  startChat(user) {
    this.wazeChatSdkPromise
      .then((sdk) => {
        sdk.startChat(user.external_info?.external_id, {
          userName: user.username,
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Failed to start Waze Chat:", error);
      });
  }

  <template>
    {{#if @outletArgs.model.can_waze_chat_user}}
      <DButton
        @class="btn-primary"
        @icon="chat"
        @label="waze.chat.user_card.start_chat"
        @action={{fn this.startChat @outletArgs.model}}
      />
    {{/if}}
  </template>
}
